module.exports = __webpack_public_path__ + "static/media/glass-champagne.6914b386.svg";